module.exports = __webpack_public_path__ + "assets/img/foto-soledad.66a00a34.png";